module.exports = "/wwwroot/img/ajax-loader.gif?ver=c7187a8b";